import { useEffect } from 'react'
import { PointsForm } from '../modules/PointsForm/PointsForm'

export function Points() {
	useEffect(() => {
		document.title = 'Подтверждение данных | Программа лояльности SK ZIC'
	}, [])

	return (
		<>
			<main style={{ width: '100%' }} id='main' role='main'>
				<PointsForm />
			</main>
		</>
	)
}
